import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import logoAHL from "@/assets/logo-ahl-blue.png";

const navigation = [
  { name: "Accueil", href: "/" },
  { name: "Services", href: "/services" },
  { name: "Flotte", href: "/flotte" },
  { name: "Tarifs", href: "/tarifs" },
  { name: "Réservation", href: "/reservation" },
  { name: "FAQ", href: "/faq" },
  { name: "Blog", href: "/blog" },
  { name: "À propos", href: "/a-propos" },
  { name: "Contact", href: "/contact" },
];

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-md border-b border-border/50 shadow-sm">
      <nav className="container mx-auto px-4 py-3 md:py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 md:gap-3">
            <img 
              alt="Azur Hybrid Luxe Logo" 
              className="h-10 md:h-14 w-auto object-contain" 
              src={logoAHL}
              width={56}
              height={56}
              loading="eager"
            />
            <span className="font-display text-sm sm:text-base md:text-xl font-bold text-primary">
              Azur Hybrid Luxe
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-6 xl:gap-8">
            {navigation.map((item) => (
              <Link 
                key={item.name} 
                to={item.href} 
                className={`text-sm font-medium transition-colors hover:text-primary ${
                  location.pathname === item.href ? "text-primary" : "text-foreground/80"
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center gap-4">
            <a 
              href="tel:+33614304966" 
              className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors"
            >
              <Phone className="h-4 w-4" />
              <span>+33 6 14 30 49 66</span>
            </a>
            <Button asChild>
              <Link to="/reservation">Réserver</Link>
            </Button>
          </div>

          {/* Mobile: Phone + Menu button */}
          <div className="flex lg:hidden items-center gap-2">
            <a 
              href="tel:+33614304966" 
              className="p-2 text-primary hover:text-primary/80 transition-colors"
              aria-label="Appeler"
            >
              <Phone className="h-5 w-5" />
            </a>
            <button 
              className="p-2 text-foreground hover:text-primary transition-colors"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label={mobileMenuOpen ? "Fermer le menu" : "Ouvrir le menu"}
            >
              {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-border pt-4 animate-in slide-in-from-top-2 duration-200">
            <div className="flex flex-col gap-3">
              {navigation.map((item) => (
                <Link 
                  key={item.name} 
                  to={item.href} 
                  onClick={() => setMobileMenuOpen(false)} 
                  className={`text-base font-medium py-2 transition-colors hover:text-primary ${
                    location.pathname === item.href ? "text-primary" : "text-foreground/80"
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <Button asChild className="w-full mt-3">
                <Link to="/reservation" onClick={() => setMobileMenuOpen(false)}>
                  Réserver maintenant
                </Link>
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};
